import React, { useEffect, useState } from "react";
import { getServiceProviderProfile } from "../../Apiservices/Auth/servers/profileServer";

export default function StripePayoutSetup() {
  const [connect, setConnect] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    getServiceProviderProfile().then(profile => {
      if (active) setConnect(profile?.stripe_connect || null);
    });
    return () => { active = false; };
  }, []);
  async function refresh(openSetup) {
    setBusy(true); setError("");
    try {
      // Same existing API: get a fresh, single-use Stripe link on each click.
      const profile = await getServiceProviderProfile();
      const current = profile?.stripe_connect;
      if (!current) throw new Error("Payout setup is unavailable. Please try again.");
      setConnect(current);
      if (openSetup && current.status !== "ready") {
        const url = new URL(current.onboarding_url);
        if (url.protocol !== "https:" || url.hostname !== "connect.stripe.com") throw new Error();
        window.location.assign(url.href);
      }
    } catch (_) { setError("Payout setup is unavailable. Refresh your status or try again later."); }
    finally { setBusy(false); }
  }
  if (!connect) return null;
  const ready = connect.status === "ready";
  return <section aria-label="Stripe payouts" style={{ padding: "16px", marginBottom: "16px", border: "1px solid #cbd5e1", borderRadius: "12px" }}>
    <h3 style={{ marginTop: 0 }}>Vendor payouts</h3>
    <p>{ready ? "Your Stripe account is ready to receive payouts." :
      connect.status === "recovery_required" ? "Contact Thurent support to resume your payout setup." :
      "Complete your identity and bank details securely with Stripe to receive payouts."}</p>
    {!ready && connect.status !== "recovery_required" && <button type="button" disabled={busy} onClick={() => refresh(true)}>
      {busy ? "Please wait…" : "Set up payouts"}
    </button>}
    <button type="button" disabled={busy} onClick={() => refresh(false)} style={{ marginLeft: "12px" }}>Refresh payout status</button>
    {error && <p role="alert">{error}</p>}
  </section>;
}
